import { message, Modal, Spin, Card, Flex, Table as TableAntd } from 'antd';
import { FaPlus } from 'react-icons/fa';
import { FieldArray, Formik } from 'formik';
import { Input } from 'formik-antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormControl from '~/components/Form/FormControl';
import { ModalFooter } from '~/components/Modal';
import Row from '~/components/Row';
import { getItems } from '~/services/hooks/items';
import { createBatches, updateBatches } from '~/services/hooks/batches';
import { useCheckAuth } from '~/components/Can/checkAuth';
import { Table } from '~/components/Table';
import { bacthesItemsColumns } from '~/tables/bacthesItems';
import Button from '~/components/Button';
import errorHandler from '~/Utils/errorHandler';

const initial = {
  description: null,
  created_by_id: null,
  batches_items: [],
};

export default function BatchesModal({ visible, onClose, batchesEdit, isMobile }) {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const [loading, setLoading] = useState(false);
  const [fetchedItems, setFetchedItems] = useState([]);
  const [initialValues, setInitialValues] = useState(initial);

  const fetchItems = async () => {
    setLoading(true);
    try {
      const response = await getItems('', 'no-paginated');
      setFetchedItems(response);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleSave = async (values, { setErrors }) => {
    setLoading(true);
    try {
      if (batchesEdit) {
        await updateBatches(values?.id, values);
        message.success(t('messages:batches.successPut'));
      } else {
        await createBatches(values);
        message.success(t('messages:batches.successPost'));
      }
      onClose();
    } catch (error) {
      console.error(error);
      setErrors(errorHandler(error));
    }
    setLoading(false);
  };

  const fluidPermissions = () => {
    if (batchesEdit) {
      return authCheck('@lots/edit');
    } else {
      return authCheck('@lots/create');
    }
  };

  useEffect(() => {
    if (visible) {
      if (batchesEdit) {
        setInitialValues(batchesEdit);
      }
      fetchItems();
    }
  }, [visible]);

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSave}
    >
      {({ isSubmitting, submitForm, values, setFieldValue, errors }) => (
        <Modal
          title={t(batchesEdit ? 'screens:batches.titlePut' : 'screens:batches.titlePost') + (values.description ?? '')}
          onCancel={onClose}
          style={{ maxWidth: isMobile ? '100%' : '1500px' }}
          afterClose={() => setInitialValues(initial)}
          open={visible}
          centered
          width={isMobile ? '100%' : '1300px'}
          footer={<ModalFooter onOk={submitForm} loading={loading || isSubmitting} onCancel={onClose} />}
        >
          <Spin spinning={loading}>
            <Card>
              <Row style={{ marginBottom: '10px' }}>
                <FormControl cols={{ xs: 24 }} field="description" label={t('fields:batch.description')}>
                  <Input.TextArea name="description" rows={4} disabled={!fluidPermissions()} />
                </FormControl>
              </Row>
              <div style={{ marginBottom: '10px' }}>
                <i style={{ color: 'red', fontStyle: 'italic' }}>
                  Bebidas em vermelho são bebidas que foram excluídas do sistema
                </i>
              </div>
              <FieldArray name="batches_items">
                {({ push, remove }) => (
                  <Table
                    dataSource={values?.batches_items?.map((bi, i) => ({
                      ...bi,
                      key: i,
                      remove,
                    }))}
                    columns={bacthesItemsColumns(fetchedItems, errors, fluidPermissions, setFieldValue)}
                    size="small"
                    rowClassName={() => 'editable-row'}
                    bordered
                    empty={false}
                    summary={() => {
                      return (
                        <TableAntd.Summary.Row>
                          <TableAntd.Summary.Cell>
                            <Flex style={{ height: '100%' }} align="flex-start" justify="center">
                              <Button
                                color="primary"
                                title="Adicionar item"
                                size="small"
                                onClick={() =>
                                  push({
                                    item_id: null,
                                    item_name: null,
                                    input_amount: null,
                                    cost_price: null,
                                    due_date: null,
                                    provider: null,
                                  })
                                }
                                style={{ width: '30px' }}
                                disabled={!fluidPermissions()}
                              >
                                <FaPlus />
                              </Button>
                            </Flex>
                          </TableAntd.Summary.Cell>
                          <TableAntd.Summary.Cell />
                          <TableAntd.Summary.Cell />
                          <TableAntd.Summary.Cell />
                          <TableAntd.Summary.Cell />
                          <TableAntd.Summary.Cell />
                        </TableAntd.Summary.Row>
                      );
                    }}
                  />
                )}
              </FieldArray>
            </Card>
          </Spin>
        </Modal>
      )}
    </Formik>
  );
}
